<template>
  <div class="animated fadeIn">
      <loader :show="enviando"/>

        <b-card header-tag="header" >
            <div slot="header">
            <strong> {{ titulo }} </strong>
            </div>
            <b-row>
                <b-col v-if="preguntas.length === 0" sm="12" md="12">
                    <p><i>No hay preguntas capturadas...</i></p>
                </b-col>
                <b-col v-else  sm="12" md="12">
                        <faq-pregunta
                            v-for="(element, index) in preguntas"
                            :key="index"
                            :pregunta="element"
                            @preguntaEliminada="preguntaEliminada"/>
                </b-col>
                <b-col sm="12" md="12" v-if="puedeAgregar">
                    <b-button 
                        class="pull-right"
                        size="sm"
                        variant="primary"
                        @click="agregaPregunta()">
                        Agregar pregunta
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import FaqPregunta from './FAQPregunta'

export default {
  name: 'TransparenciaFAQ',
  components: {
   Loader,
   FaqPregunta
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 119) >= 0 )
            return true;
        else
            return false;
    }
  },
  data: function () {
    return {
        titulo: this.$route.name,
        //titulo: '',
        enviando: false,
        preguntas: []
    }
  },
  created(){
      //Se obtienen los elementos del menú
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 118) < 0)
        this.$router.go(-1);
      this.enviando = true;
      axios.get(this.httpURL+'/transparencia/faq',{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.preguntas = res.data.preguntas;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
      agregaPregunta(){
          axios.post(this.httpURL+'/transparencia/faq',{},{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.preguntas.push(res.data.pregunta);
                  this.enviando = false;
                  this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                              text: res.data.mensaje });
              })
              .catch(error => {
                  if(error.response){
                        this.error = error.response.data.mensaje;
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                    }
                  this.enviando = false;
              });
      },
      preguntaEliminada(id){
          this.preguntas.splice(this.preguntas.findIndex(x => x._id === id),1);
      }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
